import { userContextSlice } from "@tdp/common/auth";

import { StartupFunction } from "."

export const loginStartup: StartupFunction = async (root) => {
  const { services, store } = root;
  const { auth } = services;
  //TODO(nibeauli): fire commands with the results of this login to store the values.
  const context = await auth.login();
  store.dispatch(userContextSlice.actions.updateUserContext(context));
}
